var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1661_180489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5229 12.5234V17.7522H17.0239C17.4464 16.1783 17.6974 14.3974 17.7381 12.5234H12.5229Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08313 5.20151H6.17411C6.80573 3.17171 7.71239 1.51313 8.80837 0.414062C6.03921 1.17642 3.66744 2.89357 2.08313 5.20151Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21623 12.5234H0C0.0815686 14.4183 0.588775 16.2024 1.44838 17.771C1.47975 17.7647 1.50902 17.7522 1.5425 17.7522H5.88132C5.48603 16.1699 5.25279 14.4058 5.21623 12.5234Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0238 6.25H12.5228V11.4788H17.738C17.6972 9.60475 17.4463 7.82382 17.0238 6.25Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5229 0.03125V5.20248H16.708C15.7532 2.35699 14.2338 0.371103 12.5229 0.03125Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5621 6.25H18.1177C18.513 7.8322 18.7472 9.59641 18.7838 11.4788H23.9989C23.9174 9.59117 23.4155 7.81441 22.5621 6.25Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1906 0.414062C16.2876 1.51313 17.1942 3.17171 17.8269 5.20151H21.9168C20.3315 2.89357 17.9597 1.17642 15.1906 0.414062Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43686 6.25005C0.583529 7.81446 0.0815686 9.59122 0 11.4788H5.21515C5.25279 9.59642 5.48598 7.83225 5.88127 6.25H1.43686V6.25005Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5229 18.7969V23.9681C14.2338 23.6272 15.7533 21.6413 16.708 18.7969H12.5229Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8258 18.7969C17.1942 20.8267 16.2876 22.4853 15.1906 23.5843C17.9597 22.823 20.3315 21.1059 21.9168 18.7969H17.8258Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7849 12.5234C18.7473 14.4058 18.5141 16.1699 18.1188 17.7522H22.4576C22.4911 17.7522 22.5203 17.7647 22.5517 17.771C23.4113 16.2024 23.9185 14.4183 24.0001 12.5234H18.7849Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29199 5.20248H11.4771V0.03125C9.76626 0.371103 8.2468 2.35699 7.29199 5.20248Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29199 18.7969C8.24675 21.6424 9.76626 23.6282 11.4771 23.9681V18.7969H7.29199Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17308 18.7969H2.08313C3.66847 21.1049 6.03921 22.822 8.8094 23.5843C7.71239 22.4852 6.80573 20.8267 6.17308 18.7969Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26196 12.5234C6.30275 14.3974 6.55373 16.1783 6.97623 17.7522H11.4772V12.5234H6.26196Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97623 6.25C6.55373 7.82387 6.30275 9.60475 6.26196 11.4788H11.4771V6.25H6.97623Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1661_180489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.30ed6cc8.svg";
export { ForwardRef as ReactComponent };